(function () {
  'use strict';

  var modal = document.getElementById('VideoModal');
  if (!modal) return;

  var player = document.getElementById('VideoModal-Player');
  var productPanel = document.getElementById('VideoModal-Product');
  var imagesEl = document.getElementById('VideoModal-Images');
  var titleEl = document.getElementById('VideoModal-Title');
  var priceRowEl = document.getElementById('VideoModal-PriceRow');
  var variantsEl = document.getElementById('VideoModal-Variants');
  var actionsEl = document.getElementById('VideoModal-Actions');
  var descToggle = document.getElementById('VideoModal-DescToggle');
  var descContent = document.getElementById('VideoModal-Desc');
  var recsGrid = document.getElementById('VideoModal-RecsGrid');
  var recsSection = document.getElementById('VideoModal-Recs');
  var backBtn = document.getElementById('VideoModal-Back');
  var productContent = document.getElementById('VideoModal-ProductContent');
  var collectionPanel = document.getElementById('VideoModal-Collection');
  var collectionGrid = document.getElementById('VideoModal-CollectionGrid');
  var collectionTitle = document.getElementById('VideoModal-CollectionTitle');
  var collectionLink = document.getElementById('VideoModal-CollectionLink');
  var mobileATC = document.getElementById('VideoModal-MobileATC');
  var mobileBtnInfo = document.getElementById('VideoModal-MobileBtnInfo');
  var mobileBtnATC = document.getElementById('VideoModal-MobileBtnATC');
  var mobileName = document.getElementById('VideoModal-MobileName');
  var mobilePrice = document.getElementById('VideoModal-MobilePrice');
  var scrollHint = document.getElementById('VideoModal-ScrollHint');
  var scrollBack = document.getElementById('VideoModal-ScrollBack');
  var mobileBar = document.getElementById('VideoModal-MobileBar');
  var muteBtn = modal.querySelector('.video-modal__mute');
  var muteOff = modal.querySelector('.video-modal__mute-off');
  var muteOn = modal.querySelector('.video-modal__mute-on');
  var closeBtn = modal.querySelector('.video-modal__close');
  var prevBtn = modal.querySelector('.video-modal__nav--prev');
  var nextBtn = modal.querySelector('.video-modal__nav--next');
  var container = modal.querySelector('.video-modal__container');

  var currentVideoList = [];
  var currentVideoIndex = 0;
  var currentProduct = null;
  var currentVariantId = null;
  var selectedOptions = {};
  var originalProduct = null;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var mobileDescOpen = false;
  var currentProductImages = [];
  var currentImageIndex = 0;
  var indicatorEl = document.getElementById('VideoModal-ImagesIndicator');

  /* Lightbox elements */
  var lightbox = document.getElementById('VideoModal-Lightbox');
  var lightboxImg = document.getElementById('VideoModal-LightboxImg');
  var lightboxClose = document.getElementById('VideoModal-LightboxClose');
  var lightboxPrev = document.getElementById('VideoModal-LightboxPrev');
  var lightboxNext = document.getElementById('VideoModal-LightboxNext');

  /* ===== FORMAT PRICE ===== */
  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ===== OPEN / CLOSE ===== */
  function open(videoList, index) {
    currentVideoList = videoList;
    currentVideoIndex = index;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('video-modal-open');
    mobileDescOpen = false;
    if (prevBtn) prevBtn.classList.remove('is-hidden');
    if (nextBtn) nextBtn.classList.remove('is-hidden');
    /* Ajouter une entrée dans l'historique pour intercepter le bouton retour */
    history.pushState({ videoModal: true }, '');
    loadVideo();
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.overflowX = '';
    document.documentElement.style.overflow = '';
    document.body.classList.remove('video-modal-open');
    player.pause();
    player.removeAttribute('src');
    if (mobileATC) mobileATC.style.display = 'none';
  }

  /* Bouton retour navigateur → ferme le modal au lieu de naviguer */
  window.addEventListener('popstate', function (e) {
    if (modal.classList.contains('is-open')) {
      close();
    }
  });

  function closeAndGoBack() {
    close();
    /* Retirer l'entrée d'historique ajoutée à l'ouverture */
    if (history.state && history.state.videoModal) {
      history.back();
    }
  }

  closeBtn.addEventListener('click', closeAndGoBack);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeAndGoBack();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeAndGoBack();
  });

  /* ===== NAVIGATION ===== */
  function goPrev() {
    currentVideoIndex = (currentVideoIndex - 1 + currentVideoList.length) % currentVideoList.length;
    mobileDescOpen = false;
    loadVideo();
  }
  function goNext() {
    currentVideoIndex = (currentVideoIndex + 1) % currentVideoList.length;
    mobileDescOpen = false;
    loadVideo();
  }

  prevBtn.addEventListener('click', goPrev);
  nextBtn.addEventListener('click', goNext);

  /* Swipe mobile on video */
  var touchStartX = 0;
  var videoArea = modal.querySelector('.video-modal__video');
  videoArea.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  videoArea.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) goNext(); else goPrev();
    }
  }, { passive: true });

  /* Keyboard */
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'ArrowLeft') goPrev();
    if (e.key === 'ArrowRight') goNext();
  });

  /* ===== MUTE ===== */
  if (muteBtn) {
    muteBtn.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    muteBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      var isMuted = player.muted;
      player.muted = !isMuted;
      if (muteOff) muteOff.style.display = player.muted ? 'block' : 'none';
      if (muteOn) muteOn.style.display = player.muted ? 'none' : 'block';
    });
  }

  /* ===== VOLUME KEYS (mobile) — démute automatiquement ===== */
  document.addEventListener('volumechange', function () {
    if (modal.classList.contains('is-open') && player.muted) {
      player.muted = false;
      if (muteOff) muteOff.style.display = 'none';
      if (muteOn) muteOn.style.display = 'block';
    }
  });

  /* Fallback : écouter les touches volume via keydown (certains navigateurs) */
  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'AudioVolumeUp' || e.key === 'AudioVolumeDown' || e.keyCode === 175 || e.keyCode === 174) {
      if (player.muted) {
        player.muted = false;
        if (muteOff) muteOff.style.display = 'none';
        if (muteOn) muteOn.style.display = 'block';
      }
    }
  });

  /* ===== DESCRIPTION TOGGLE ===== */
  descToggle.addEventListener('click', function () {
    descToggle.classList.toggle('is-open');
    descContent.classList.toggle('is-open');
  });

  /* ===== MOBILE — scroll snap entre vidéo et description ===== */
  function showProductPanel() {
    if (container) {
      productPanel.scrollIntoView({ behavior: 'smooth' });
      mobileDescOpen = true;
      if (scrollHint) scrollHint.classList.add('is-flipped');
      if (scrollBack) scrollBack.style.display = '';
      if (mobileBar) mobileBar.classList.add('is-scrolled');
      descToggle.classList.add('is-open');
      descContent.classList.add('is-open');
    }
  }

  function hideProductPanel() {
    if (container) {
      container.scrollTo({ top: 0, behavior: 'smooth' });
      mobileDescOpen = false;
      if (scrollHint) scrollHint.classList.remove('is-flipped');
      if (scrollBack) scrollBack.style.display = 'none';
      if (mobileBar) mobileBar.classList.remove('is-scrolled');
    }
  }

  /* Détecter la position du scroll pour mettre à jour l'état */
  if (isMobile && container) {
    container.addEventListener('scroll', function () {
      var scrolled = container.scrollTop > container.offsetHeight * 0.5;
      if (scrolled && !mobileDescOpen) {
        mobileDescOpen = true;
        if (scrollHint) scrollHint.classList.add('is-flipped');
        if (scrollBack) scrollBack.style.display = '';
        if (mobileBar) mobileBar.classList.add('is-scrolled');
        if (prevBtn) prevBtn.classList.add('is-hidden');
        if (nextBtn) nextBtn.classList.add('is-hidden');
      } else if (!scrolled && mobileDescOpen) {
        mobileDescOpen = false;
        if (scrollHint) scrollHint.classList.remove('is-flipped');
        if (scrollBack) scrollBack.style.display = 'none';
        if (mobileBar) mobileBar.classList.remove('is-scrolled');
        if (prevBtn) prevBtn.classList.remove('is-hidden');
        if (nextBtn) nextBtn.classList.remove('is-hidden');
      }
    }, { passive: true });
  }

  if (scrollHint) {
    scrollHint.addEventListener('click', function () {
      showProductPanel();
    });
  }

  /* Clic sur le titre produit mobile → ouvre la description */
  if (mobileName) {
    mobileName.style.cursor = 'pointer';
    mobileName.addEventListener('click', function () {
      if (!mobileDescOpen) showProductPanel();
    });
  }

  if (scrollBack) {
    scrollBack.addEventListener('click', function () {
      hideProductPanel();
    });
  }

  /* ===== MOBILE BUTTONS — 1er clic ouvre description, 2ème clic action ===== */
  if (mobileBtnATC) {
    mobileBtnATC.addEventListener('click', function () {
      if (isMobile && !mobileDescOpen) {
        showProductPanel();
        return;
      }
      addToCart();
    });
  }

  if (mobileBtnInfo) {
    mobileBtnInfo.addEventListener('click', function (e) {
      if (isMobile && !mobileDescOpen) {
        e.preventDefault();
        showProductPanel();
        return;
      }
      /* 2ème clic = aller sur la fiche produit */
    });
  }

  /* ===== LOAD VIDEO ===== */
  function loadVideo() {
    var item = currentVideoList[currentVideoIndex];
    if (!item) return;

    player.src = item.videoUrl;
    player.muted = true;
    player.loop = true;
    player.play().catch(function () {});

    muteOff.style.display = 'block';
    muteOn.style.display = 'none';

    /* Reset */
    backBtn.classList.remove('is-visible');
    originalProduct = null;

    /* Reset mobile — retour à la vidéo + forcer le layout */
    if (isMobile && container) {
      container.scrollTop = 0;
      mobileDescOpen = false;
      if (scrollHint) scrollHint.classList.remove('is-flipped');
      if (scrollBack) scrollBack.style.display = 'none';
      if (mobileBar) mobileBar.classList.remove('is-scrolled');
      /* Forcer le recalcul du layout après chargement vidéo */
      setTimeout(function () {
        container.scrollTop = 0;
      }, 100);
      setTimeout(function () {
        container.scrollTop = 0;
      }, 300);
    }

    /* Show/hide nav arrows based on video count */
    if (currentVideoList.length > 1) {
      prevBtn.style.display = '';
      nextBtn.style.display = '';
    } else {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
    }

    if (item.productHandle) {
      collectionPanel.classList.remove('is-active');
      productContent.style.display = '';
      loadProduct(item.productHandle);
    } else if (item.collectionHandle) {
      productContent.style.display = 'none';
      collectionPanel.classList.add('is-active');
      loadCollection(item.collectionHandle);
      if (mobileATC) mobileATC.style.display = 'none';
      if (mobileName) mobileName.textContent = '';
      if (mobilePrice) mobilePrice.textContent = '';
    }

    productPanel.scrollTop = 0;
  }

  /* ===== LOAD PRODUCT ===== */
  function loadProduct(handle) {
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        currentProduct = product;
        renderProduct(product);
        loadRecommendations(product.id);
        if (mobileATC) mobileATC.style.display = '';
      })
      .catch(function () {
        titleEl.textContent = 'Produit non disponible';
      });
  }

  /* ===== RENDER PRODUCT ===== */
  function renderProduct(product) {
    /* Images — avec clic pour activer + lightbox mobile */
    imagesEl.innerHTML = '';
    var images = product.images || [];
    currentProductImages = images;
    currentImageIndex = 0;

    images.slice(0, 8).forEach(function (img, i) {
      var imgEl = document.createElement('img');
      imgEl.src = img.replace(/(\.\w+)(\?|$)/, '_400x$1$2');
      imgEl.alt = product.title;
      imgEl.loading = 'lazy';
      imgEl.dataset.index = i;
      imgEl.dataset.fullSrc = img.replace(/(\.\w+)(\?|$)/, '_1200x$1$2');
      if (i === 0) imgEl.classList.add('is-active');

      imgEl.addEventListener('click', function () {
        if (imgEl.classList.contains('is-active')) {
          /* 2ème clic sur image active → lightbox */
          openLightbox(i);
        } else {
          /* 1er clic → activer cette image */
          imagesEl.querySelectorAll('img').forEach(function (x) { x.classList.remove('is-active'); });
          imgEl.classList.add('is-active');
          currentImageIndex = i;
          imgEl.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          updateVariantFromImage(product, i);
          updateIndicator(i);
        }
      });

      imagesEl.appendChild(imgEl);
    });

    buildIndicator(Math.min(images.length, 8), 0);

    /* Title */
    titleEl.textContent = product.title;

    /* Mobile overlay */
    if (mobileName) mobileName.textContent = product.title;

    /* Variant init */
    var variant = product.variants[0];
    selectedOptions = {};
    currentVariantId = variant.id;

    renderPriceRow(variant, product);
    renderVariants(product);
    renderActions(product);

    /* Description — ouverte par défaut */
    var desc = product.body_html || product.description || '';
    descContent.innerHTML = desc;
    if (desc) {
      descContent.classList.add('is-open');
      descToggle.classList.add('is-open');
    } else {
      descContent.classList.remove('is-open');
      descToggle.classList.remove('is-open');
    }

    /* Mobile info link */
    if (mobileBtnInfo) mobileBtnInfo.href = '/products/' + product.handle;

    /* View all link — adapté à la collection du produit */
    if (viewAllLink) {
      var collectionMap = {
        'fontaine-cascade-encens': { url: '/collections/fontaine-cascade-encens', label: 'Voir toutes nos fontaines' },
        'bruleur-d-encens': { url: '/collections/bruleur-d-encens', label: 'Voir tous nos brûleurs' },
        'kits-accessoires-encens': { url: '/collections/kits-accessoires-encens', label: "Voir tous nos kits d'encens" },
        'diffuseurs-ultrasoniques': { url: '/pages/diffuseurs', label: 'Voir tous nos diffuseurs' },
        'diffuseur-chaleur-douce': { url: '/pages/diffuseurs', label: 'Voir tous nos diffuseurs' },
        'huiles-essentielles-encens': { url: '/pages/diffuseurs', label: 'Voir tous nos diffuseurs' },
        'cones-encens': { url: '/collections/cones-encens', label: "Voir tous nos cônes d'encens" },
        'encens-poudres': { url: '/collections/encens-poudres', label: "Voir tous nos encens en poudre" },
        'porte-encens-batons': { url: '/collections/porte-encens-batons', label: 'Voir tous nos porte-encens' }
      };

      var found = false;
      var item = currentVideoList[currentVideoIndex];

      /* Chercher d'abord via le handle de la vidéo */
      if (item && item.collectionHandle && collectionMap[item.collectionHandle]) {
        var mapped = collectionMap[item.collectionHandle];
        viewAllLink.href = mapped.url;
        viewAllLink.textContent = mapped.label + ' →';
        found = true;
      }

      /* Sinon chercher dans les collections du produit */
      if (!found && product.collections) {
        for (var ci = 0; ci < product.collections.length; ci++) {
          var ch = product.collections[ci].handle;
          if (collectionMap[ch]) {
            viewAllLink.href = collectionMap[ch].url;
            viewAllLink.textContent = collectionMap[ch].label + ' →';
            found = true;
            break;
          }
        }
      }

      if (!found) {
        /* Fallback : deviner via le handle produit */
        var h = product.handle || '';
        if (h.indexOf('fontaine') !== -1 || h.indexOf('cascade') !== -1) {
          viewAllLink.href = '/collections/fontaine-cascade-encens';
          viewAllLink.textContent = 'Voir toutes nos fontaines →';
        } else if (h.indexOf('bruleur') !== -1) {
          viewAllLink.href = '/collections/bruleur-d-encens';
          viewAllLink.textContent = 'Voir tous nos brûleurs →';
        } else if (h.indexOf('kit') !== -1 || h.indexOf('coffret') !== -1) {
          viewAllLink.href = '/collections/kits-accessoires-encens';
          viewAllLink.textContent = "Voir tous nos kits d'encens →";
        } else if (h.indexOf('diffuseur') !== -1) {
          viewAllLink.href = '/pages/diffuseurs';
          viewAllLink.textContent = 'Voir tous nos diffuseurs →';
        } else {
          viewAllLink.href = '/collections/all';
          viewAllLink.textContent = 'Voir tous nos produits →';
        }
      }
    }
  }

  function renderPriceRow(variant, product) {
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<span class="video-modal__compare-price">' + formatPrice(variant.compare_at_price) + '</span>';
      html += '<span class="video-modal__price">' + formatPrice(variant.price) + '</span>';
      html += '<span class="video-modal__badge video-modal__badge--sale">Promo</span>';
    } else {
      html += '<span class="video-modal__price">' + formatPrice(variant.price) + '</span>';
    }
    if (product.tags && product.tags.indexOf('Nouveautés') !== -1) {
      html += '<span class="video-modal__badge video-modal__badge--new">Nouv.</span>';
    }
    priceRowEl.innerHTML = html;

    /* Mobile price */
    if (mobilePrice) mobilePrice.textContent = formatPrice(variant.price);
  }

  /* ===== RENDER VARIANTS ===== */
  function renderVariants(product) {
    variantsEl.innerHTML = '';
    if (!product.options || product.options.length === 0) return;
    if (product.options.length === 1 && product.variants.length === 1) return;

    product.options.forEach(function (option, optIdx) {
      var values = option.values || [];
      if (values.length <= 1) return;

      selectedOptions[option.name] = product.variants[0].options[optIdx];

      var group = document.createElement('div');
      group.className = 'video-modal__variant-group';

      var label = document.createElement('span');
      label.className = 'video-modal__variant-label';
      label.textContent = option.name;
      group.appendChild(label);

      if (values.length <= 3) {
        var bubbles = document.createElement('div');
        bubbles.className = 'video-modal__variant-bubbles';

        values.forEach(function (val) {
          var btn = document.createElement('button');
          btn.className = 'video-modal__variant-bubble';
          btn.textContent = val;
          if (val === selectedOptions[option.name]) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            selectedOptions[option.name] = val;
            bubbles.querySelectorAll('.video-modal__variant-bubble').forEach(function (b) { b.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            updateVariant(product);
          });
          bubbles.appendChild(btn);
        });
        group.appendChild(bubbles);
      } else {
        var drawer = document.createElement('div');
        drawer.className = 'video-modal__variant-drawer';

        var toggle = document.createElement('button');
        toggle.className = 'video-modal__variant-drawer-toggle';
        toggle.innerHTML = '<span>' + selectedOptions[option.name] + '</span><svg viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"></polyline></svg>';

        var opts = document.createElement('div');
        opts.className = 'video-modal__variant-options';

        values.forEach(function (val) {
          var opt = document.createElement('div');
          opt.className = 'video-modal__variant-option';
          if (val === selectedOptions[option.name]) opt.classList.add('is-selected');
          opt.textContent = val;
          opt.addEventListener('click', function () {
            selectedOptions[option.name] = val;
            toggle.querySelector('span').textContent = val;
            opts.classList.remove('is-open');
            opts.querySelectorAll('.video-modal__variant-option').forEach(function (o) { o.classList.remove('is-selected'); });
            opt.classList.add('is-selected');
            updateVariant(product);
          });
          opts.appendChild(opt);
        });

        toggle.addEventListener('click', function () { opts.classList.toggle('is-open'); });
        drawer.appendChild(opts);
        drawer.appendChild(toggle);
        group.appendChild(drawer);
      }

      variantsEl.appendChild(group);
    });
  }

  function updateVariant(product) {
    var match = product.variants.find(function (v) {
      return product.options.every(function (opt, i) {
        return v.options[i] === selectedOptions[opt.name];
      });
    });

    if (match) {
      currentVariantId = match.id;
      renderPriceRow(match, product);

      /* Mettre à jour l'image si la variante a une image */
      if (match.featured_image && match.featured_image.position) {
        var imgs = imagesEl.querySelectorAll('img');
        var idx = match.featured_image.position - 1;
        imgs.forEach(function (img) { img.classList.remove('is-active'); });
        if (imgs[idx]) {
          imgs[idx].classList.add('is-active');
          imgs[idx].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          currentImageIndex = idx;
          updateIndicator(idx);
        }
      }
    }
  }

  /* ===== RENDER ACTIONS ===== */
  function renderActions(product) {
    actionsEl.innerHTML = '';

    var infoLink = document.createElement('a');
    infoLink.className = 'video-modal__btn-info';
    infoLink.href = '/products/' + product.handle;
    infoLink.textContent = "Plus d'informations";
    actionsEl.appendChild(infoLink);

    var atcBtn = document.createElement('button');
    atcBtn.className = 'video-modal__btn-atc';
    atcBtn.textContent = 'Ajouter au panier';
    atcBtn.addEventListener('click', function () { addToCart(); });
    actionsEl.appendChild(atcBtn);
  }

  /* ===== ADD TO CART ===== */
  function addToCart() {
    if (!currentVariantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: currentVariantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        var btns = modal.querySelectorAll('.video-modal__btn-atc');
        btns.forEach(function (b) {
          var orig = b.textContent;
          b.textContent = 'Ajouté ✓';
          b.style.backgroundColor = '#8B5E3C';
          setTimeout(function () {
            b.textContent = orig;
            b.style.backgroundColor = '';
          }, 1500);
        });

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var counters = document.querySelectorAll('.cart-count-bubble span[aria-hidden]');
            counters.forEach(function (c) { c.textContent = cart.item_count; });

            /* Rafraîchir et ouvrir le cart drawer */
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              close();
              /* Rafraîchir le contenu du drawer via Section Rendering API */
              fetch('/?sections=cart-drawer')
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  var html = sections['cart-drawer'];
                  if (html) {
                    var temp = document.createElement('div');
                    temp.innerHTML = html;
                    var newDrawer = temp.querySelector('cart-drawer');
                    if (newDrawer && cartDrawer.parentNode) {
                      cartDrawer.parentNode.replaceChild(newDrawer, cartDrawer);
                    }
                  }
                  /* Ouvrir le drawer */
                  setTimeout(function () {
                    var drawer = document.querySelector('cart-drawer');
                    if (drawer) {
                      drawer.classList.remove('is-empty');
                      var innerDrawer = drawer.querySelector('.drawer');
                      if (innerDrawer) innerDrawer.classList.add('active');
                      document.body.classList.add('overflow-hidden');
                    }
                  }, 100);
                });
            }
          });
      })
      .catch(function () {});
  }

  /* ===== LOAD RECOMMENDATIONS ===== */
  function loadRecommendations(productId) {
    recsGrid.innerHTML = '';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (products.length === 0) {
          recsSection.style.display = 'none';
          return;
        }
        recsSection.style.display = '';
        products.slice(0, 6).forEach(function (p) { renderRecCard(p); });
      })
      .catch(function () { recsSection.style.display = 'none'; });
  }

  function renderRecCard(product) {
    var card = document.createElement('div');
    card.className = 'video-modal__rec-card';

    var img = document.createElement('img');
    img.src = product.featured_image ? product.featured_image.replace(/(\.\w+)(\?|$)/, '_300x$1$2') : '';
    img.alt = product.title;
    img.loading = 'lazy';
    card.appendChild(img);

    var info = document.createElement('div');
    info.className = 'video-modal__rec-info';

    var title = document.createElement('div');
    title.className = 'video-modal__rec-title';
    title.textContent = product.title;
    info.appendChild(title);

    var priceRow = document.createElement('div');
    priceRow.className = 'video-modal__rec-price-row';

    var variant = product.variants[0];
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceRow.innerHTML = '<span class="video-modal__rec-compare">' + formatPrice(variant.compare_at_price) + '</span>'
        + '<span class="video-modal__rec-price">' + formatPrice(variant.price) + '</span>'
        + '<span class="video-modal__rec-badge video-modal__rec-badge--sale">Promo</span>';
    } else {
      priceRow.innerHTML = '<span class="video-modal__rec-price">' + formatPrice(variant.price) + '</span>';
    }
    if (product.tags && product.tags.indexOf('Nouveautés') !== -1) {
      priceRow.innerHTML += '<span class="video-modal__rec-badge video-modal__rec-badge--new">Nouv.</span>';
    }

    info.appendChild(priceRow);
    card.appendChild(info);

    card.addEventListener('click', function () {
      if (!originalProduct) originalProduct = currentProduct;
      backBtn.classList.add('is-visible');
      productPanel.scrollTop = 0;
      loadProduct(product.handle);
    });

    recsGrid.appendChild(card);
  }

  /* ===== BACK BUTTON ===== */
  backBtn.addEventListener('click', function () {
    if (originalProduct) {
      currentProduct = originalProduct;
      renderProduct(originalProduct);
      loadRecommendations(originalProduct.id);
      originalProduct = null;
      backBtn.classList.remove('is-visible');
      productPanel.scrollTop = 0;
    }
  });

  /* ===== LOAD COLLECTION ===== */
  function loadCollection(handle) {
    collectionGrid.innerHTML = '';
    collectionTitle.textContent = 'Découvrir la collection';
    collectionLink.href = '/collections/' + handle;

    fetch('/collections/' + handle + '/products.json?limit=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        products.slice(0, 8).forEach(function (p) {
          var card = document.createElement('div');
          card.className = 'video-modal__rec-card';

          var img = document.createElement('img');
          img.src = p.images[0] ? p.images[0].src.replace(/(\.\w+)(\?|$)/, '_300x$1$2') : '';
          img.alt = p.title;
          img.loading = 'lazy';
          card.appendChild(img);

          var info = document.createElement('div');
          info.className = 'video-modal__rec-info';

          var title = document.createElement('div');
          title.className = 'video-modal__rec-title';
          title.textContent = p.title;
          info.appendChild(title);

          var priceRow = document.createElement('div');
          priceRow.className = 'video-modal__rec-price-row';

          var v = p.variants[0];
          if (v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price)) {
            priceRow.innerHTML = '<span class="video-modal__rec-compare">' + parseFloat(v.compare_at_price).toFixed(2).replace('.', ',') + ' €</span>'
              + '<span class="video-modal__rec-price">' + parseFloat(v.price).toFixed(2).replace('.', ',') + ' €</span>'
              + '<span class="video-modal__rec-badge video-modal__rec-badge--sale">Promo</span>';
          } else {
            priceRow.innerHTML = '<span class="video-modal__rec-price">' + parseFloat(v.price).toFixed(2).replace('.', ',') + ' €</span>';
          }
          if (p.tags && p.tags.indexOf('Nouveautés') !== -1) {
            priceRow.innerHTML += '<span class="video-modal__rec-badge video-modal__rec-badge--new">Nouv.</span>';
          }

          info.appendChild(priceRow);
          card.appendChild(info);

          card.addEventListener('click', function () {
            collectionPanel.classList.remove('is-active');
            productContent.style.display = '';
            backBtn.classList.add('is-visible');
            originalProduct = null;
            loadProduct(p.handle);
          });

          collectionGrid.appendChild(card);
        });
      });
  }

  /* ===== IMAGE INDICATOR (dots) ===== */
  function buildIndicator(count, activeIdx) {
    if (!indicatorEl) return;
    indicatorEl.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'video-modal__images-dot';
      if (i === activeIdx) dot.classList.add('is-active');
      (function (idx) {
        dot.addEventListener('click', function () {
          var imgs = imagesEl.querySelectorAll('img');
          if (imgs[idx]) {
            imgs[idx].click();
          }
        });
      })(i);
      indicatorEl.appendChild(dot);
    }
  }

  function updateIndicator(activeIdx) {
    if (!indicatorEl) return;
    var dots = indicatorEl.querySelectorAll('.video-modal__images-dot');
    dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === activeIdx);
    });
  }

  /* ===== DRAG TO SCROLL (images) ===== */
  (function () {
    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;

    imagesEl.addEventListener('mousedown', function (e) {
      isDragging = true;
      imagesEl.classList.add('is-dragging');
      startX = e.pageX - imagesEl.offsetLeft;
      scrollLeft = imagesEl.scrollLeft;
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      var x = e.pageX - imagesEl.offsetLeft;
      imagesEl.scrollLeft = scrollLeft - (x - startX);
    });

    document.addEventListener('mouseup', function () {
      isDragging = false;
      imagesEl.classList.remove('is-dragging');
    });
  })();

  /* ===== LIGHTBOX ===== */
  function openLightbox(idx) {
    if (!lightbox || currentProductImages.length === 0) return;
    currentImageIndex = idx;
    var src = currentProductImages[idx] || '';
    lightboxImg.src = src.replace(/(\.\w+)(\?|$)/, '_1200x$1$2');
    lightbox.style.display = 'flex';
  }

  function closeLightbox() {
    if (lightbox) lightbox.style.display = 'none';
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () {
    currentImageIndex = (currentImageIndex - 1 + currentProductImages.length) % currentProductImages.length;
    lightboxImg.src = currentProductImages[currentImageIndex].replace(/(\.\w+)(\?|$)/, '_1200x$1$2');
  });
  if (lightboxNext) lightboxNext.addEventListener('click', function () {
    currentImageIndex = (currentImageIndex + 1) % currentProductImages.length;
    lightboxImg.src = currentProductImages[currentImageIndex].replace(/(\.\w+)(\?|$)/, '_1200x$1$2');
  });

  /* ===== IMAGE → VARIANTE (clic image change la variante) ===== */
  function updateVariantFromImage(product, imgIndex) {
    if (!product || !product.variants) return;
    /* Trouver une variante dont le featured_image.position correspond */
    var match = product.variants.find(function (v) {
      return v.featured_image && v.featured_image.position === imgIndex + 1;
    });
    if (match) {
      currentVariantId = match.id;
      /* Mettre à jour les selectedOptions */
      product.options.forEach(function (opt, i) {
        selectedOptions[opt.name] = match.options[i];
      });
      renderPriceRow(match, product);
      /* Mettre à jour les bulles/drawers visuellement */
      renderVariants(product);
    }
  }

  /* ===== VIEW ALL LINK ===== */
  var viewAllLink = document.getElementById('VideoModal-ViewAll');

  /* ===== PUBLIC API ===== */
  window.VideoModal = {
    open: open,
    close: close
  };

})();
